import React from "react";
import { FaCoins, FaHospitalUser, FaSignal, FaUsers } from "react-icons/fa";
import { proofStats } from "../data/siteData";

const iconMap = [FaHospitalUser, FaUsers, FaSignal, FaCoins];
const meterMap = [
  { value: 82, color: "var(--brand)" },
  { value: 94, color: "#5f3484" },
  { value: 100, color: "#1d9e75" },
  { value: 72, color: "#8b3689" },
];

function ProofBarSection() {
  return (
    <section className="proofbar">
      <div className="proofbar__grid">
        {proofStats.map((item, index) => {
          const Icon = iconMap[index] || FaSignal;
          const meter = meterMap[index] || meterMap[0];

          return (
            <div key={item.label} className="proofbar__circle-wrap">
              <div
                className="proofbar__circle"
                style={{ "--proof-color": meter.color }}
              >
                <div className="proofbar__circle-inner">
                  <span className="proofbar__icon" style={{ color: meter.color }}>
                    <Icon />
                  </span>
                  <span className="proofbar__value">{item.value}</span>
                  <span className="proofbar__label">{item.label}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default ProofBarSection;
